/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { TypeMoney } from '../models/TypeMoney';
import { HttpFile } from '../http/http';

export class V1OrderLineCPMOverriden {
    'requestId'?: string;
    'userId'?: string;
    'timestamp'?: Date;
    'orderLineId'?: string;
    'orgId'?: string;
    'cpmOverride'?: TypeMoney;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "requestId",
            "baseName": "request_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "userId",
            "baseName": "user_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "timestamp",
            "baseName": "timestamp",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "orderLineId",
            "baseName": "order_line_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "orgId",
            "baseName": "org_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "cpmOverride",
            "baseName": "cpm_override",
            "type": "TypeMoney",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V1OrderLineCPMOverriden.attributeTypeMap;
    }

    public constructor() {
    }
}

